import * as React from "react";
import { forwardRef } from "react";
const SvgAdOrganizationalUnit = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "#0078D4", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, viewBox: "0 0 24 24", width: "1em", height: "1em", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4 20h16M4 20V8l8-4 8 4v12" }), /* @__PURE__ */ React.createElement("path", { d: "M9 12h6v8H9zM10 16h4m-4 2h4" }));
const ForwardRef = forwardRef(SvgAdOrganizationalUnit);
export default ForwardRef;
